import React from 'react';
import './styles/index.css';
import './styles/footer.css';
import tgLogo from './images/tgLogo.svg'
import vkLogo from './images/vkLogo.svg'
import ytLogo from './images/ytLogo.svg'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="sticky-footer">
      <div id="footer-container">
        <div>
          <ul className="links">
            <span className='links_title'><b>Ссылки</b></span><br />
              <li><a className="link-yt" href="https://www.youtube.com/@mtv-media"><img src= {ytLogo} className="icon" alt="YouTube-канал"/></a></li>
              <li><a className="link-tg" href="https://t.me/kanal_mtv2019"><img src= {tgLogo} className="icon" alt="Телеграм-канал"/></a></li>
              <li><a className="link-vk" href="https://vk.com/mtv_media"><img src= {vkLogo} className="icon" alt="Группа ВК"/></a></li>
          </ul>
          <ul className="add-links">
            <b>Дополнительно</b><br />
            <li><a className="link-pwa" href="https://pwa.mtv-media.ru/">Приложение МТВ (Бета)</a></li>
            <li><a className="link-test" href="/test.html">Тест</a></li>
            <li><a className="link-privacy" href="/privacy-policy">Политика конфиденциальности</a></li>
          </ul>
        </div>
      </div>
      <div className="copyright">
        <h5>&copy;2019–{currentYear}, mtv-media</h5>
      </div>
    </footer>
  );
};

export default Footer;